import { processCorrelations } from "@/_core/data/api_calls/correlations/processCorrelations";
import { gatewayService } from "@/_services/gateway.service";

export function getCurrencyCorrelations(ctx) {
  const variables = {
    format: "json",
    currency: ctx.currencyNumber
  };
  return processCorrelations(ctx, {
    fetch: gatewayService.market.correlations,
    variables
  });
}
